import moment from 'moment';

class DateSelectorController {

	$onInit() {
		this.dates = [
			new Date(new Date().setDate(new Date().getDate() + 0)),
			new Date(new Date().setDate(new Date().getDate() + 1)),
			new Date(new Date().setDate(new Date().getDate() + 2)),
		];
		this.isInitial = true;
	}

	/*
     *Show next and previous dates in carousel
     */
	move(add) {
		let aux = this.dates.map(date => {
			let auxDate = angular.copy(date);
			return new Date(auxDate.setDate(auxDate.getDate() + add));
		});
		this.dates = aux;
		if (add > 0)
			this.isInitial = false;
		else if (this.dates[0] && this.dates[0].getMonth() === new Date().getMonth() && this.dates[0].getDate() === new Date().getDate())
			this.isInitial = true;

		if (angular.isFunction(this.onChange))
			this.onChange({
				$event: {
					values: this.dates
				}
			});
	}

	/*
     * Apply format to a date
     */
	format(date, format) {
		return moment(date).format(format);
	}
}

export default DateSelectorController;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/date-selector/date-selector.controller.js